import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axiosInstance';

// Thunk to fetch device alerts
export const fetchDeviceAlerts = createAsyncThunk(
  'dashboard/fetchDeviceAlerts',
  async (params = {}, { rejectWithValue }) => {
    try {
      let url = '/api/devicealerts';
      const query = [];
  if (params.deviceId) query.push(`deviceId=${params.deviceId}`);
  if (params.userId) query.push(`userId=${params.userId}`);
  if (params.limit) query.push(`limit=${params.limit}`);
  if (params.page) query.push(`page=${params.page}`);
  if (params.offset) query.push(`offset=${params.offset}`);
  if (params.alertType) query.push(`alertType=${params.alertType}`);
  if (params.deviceName) query.push(`deviceName=${encodeURIComponent(params.deviceName)}`);
      if (query.length) url += `?${query.join('&')}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch device alerts');
    }
  }
);

// Thunk to fetch device notifications
export const fetchDeviceNotifications = createAsyncThunk(
  'dashboard/fetchDeviceNotifications',
  async (userId, { rejectWithValue }) => {
    try {  
      const response = await axiosInstance.get(`/api/user-notification-settings/user/${userId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch device notifications');
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    deviceAlerts: [],
    deviceNotifications: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchDeviceAlerts.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeviceAlerts.fulfilled, (state, action) => {
        state.loading = false;
        state.deviceAlerts = action.payload || [];
      })
      .addCase(fetchDeviceAlerts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDeviceNotifications.fulfilled, (state, action) => {
        state.deviceNotifications = action.payload || [];
      });
  },
});

export default dashboardSlice.reducer;
